<template>
	<div class="space-y-32 mb-44">
		<div class="relative">
			<div class="absolute w-full z-10 pt-64">
				<Container>
					<div class="grid place-items-center">
						<div class="max-w-2xl text-center">
							<div class="flex justify-center items-center mb-6 text-white">
								<NuxtLink to="/" class="hover:underline">{{
									$t("nav.home")
								}}</NuxtLink>
								<span class="mx-2">→</span>
								<span class="text-white/80">{{ $t("nav.about") }}</span>
							</div>

							<div class="space-y-6">
								<div class="text-white text-2xl">
									<h1>{{ $t("about.sub_title") }}</h1>
								</div>
								<h2
									class="text-3xl md:text-[40px] md:leading-[49.1px] text-white"
								>
									{{ $t("about.title") }}
								</h2>
								<div
									class="text-lg leading-5 md:text-xl text-white font-general-sans"
								>
									<h3>{{ $t("about.desc") }}</h3>
									<br />
									<h3>{{ $t("about.desc.2") }}</h3>
								</div>
							</div>
						</div>
					</div>
				</Container>
			</div>

			<div class="-mt-20">
				<div class="relative">
					<div
						class="absolute h-full w-full bg-gradient-to-t from-black/50 to-black/80"
					></div>
					<NuxtImg
						src="/banner-about.jpg"
						densities="x1 x2"
						format="webp"
						height="680"
						alt="about hero"
						class="w-full h-[1000px] min-h-[580px] object-cover"
						sizes="100vw sm:50vw md:680px"
						loading="lazy"
					/>
				</div>
			</div>
		</div>

		<!-- <div>
      <Container class="space-y-3">
        <h2 class="font-medium">SURYA BINTANG ADVENTURES</h2>
        <div class="font-general-sans text-xl">
          {{ $t('about_txt') }}
        </div>

        <p>
          Best Regards,<br /><br />
          <span>SURYA BINTANG ADVENTURES</span>
        </p>
      </Container>
    </div> -->

		<div>
			<Container>
				<div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
					<div class="space-y-8 p-2">
						<!-- <div class="font-general-sans text-2xl font-medium">
              {{ $t('about.vission') }}
              <Icon name="i-heroicons-arrow-right" class="rotate-45" />
            </div>
            <div class="text-[40px] leading-[49px]">
              {{ $t('about.vission_desc') }}
            </div> -->

						<div>
							<NuxtImg
								src="/about-vision.jpg"
								alt="vision hero"
								class="h-full w-full"
								format="webp"
							/>
						</div>
					</div>

					<div class="space-y-6 p-2">
						<div>
							<div class="font-general-sans text-2xl font-medium">
								<h3>{{ $t("about.mission") }}</h3>
							</div>
						</div>

						<p class="font-general-sans text-xl">
							{{ $t("about.mission_1") }}
						</p>
						<p class="font-general-sans font-medium text-xl">
							{{ $t("about.mission_2") }}
						</p>
						<p class="font-general-sans text-xl">
							{{ $t("about.mission_3") }}
						</p>
						<p class="font-general-sans font-medium text-xl">
							{{ $t("about.mission_4") }}
						</p>
						<p class="font-general-sans text-xl">
							{{ $t("about.mission_5") }}
						</p>
					</div>
				</div>
			</Container>
		</div>

		<div>
			<Container>
				<div class="space-y-8">
					<div class="grid grid-cols-1 md:grid-cols-3">
						<div>
							<div class="text-3xl md:text-[40px] md:leading-[49.1px]">
								<h3>{{ $t("our_team") }}</h3>
							</div>
						</div>
						<div class="md:col-span-2 text-xl">
							<h4>{{ $t("team_desc") }}</h4>
						</div>
					</div>
					<TeamSwiper />
				</div>
			</Container>
		</div>

		<div>
			<Container>
				<div class="space-y-8">
					<div class="grid grid-cols-1 md:grid-cols-3">
						<div>
							<div class="text-3xl md:text-[40px] md:leading-[49.1px]">
								<h3>{{ $t("about.activities_text") }}</h3>
							</div>
						</div>
						<div class="md:col-span-2 text-xl">
							<p>{{ $t("about.activities_desc") }}</p>
							<br />
							<p>{{ $t("about.activities_desc_2") }}</p>
							<br />
							<p>{{ $t("about.activities_desc_3") }}</p>
							<br />
							<p>{{ $t("about.activities_desc_4") }}</p>
						</div>
					</div>
					<!-- <div class="flex flex-col md:flex-row md:space-x-8 text-xl md:overflow-x-auto">
            <div class="whitespace-nowrap">Swing</div>
            <div class="whitespace-nowrap">Rafting</div>
            <div class="whitespace-nowrap">ATV</div>
            <div class="whitespace-nowrap">Cycling</div>
            <div class="whitespace-nowrap">Trekking</div>
          </div>
          <ClientOnly>
            <ActivityOnlyImageSlideTop />
          </ClientOnly> -->
				</div>
			</Container>
		</div>

		<!-- <div>
      <Container>
        <div class="space-y-8">
          <div class="grid grid-cols-1 md:grid-cols-3">
            <div>
              <div class="text-3xl md:text-[40px] md:leading-[49.1px]">
                {{ $t('about.experience_text') }}
              </div>
            </div>
            <div class="md:col-span-2 text-xl">
              {{ $t('about.experience_desc') }}
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:space-x-8 text-xl md:overflow-x-auto">
            <div class="whitespace-nowrap">Team Building & Fun Games</div>
          </div>
          <ClientOnly>
            <ActivityOnlyImageSlide reverse />
          </ClientOnly>
        </div>
      </Container>
    </div> -->
	</div>
</template>

<script setup lang="ts">
const { t: $t } = useI18n();
const { href } = useCanonical();

useSeoMeta({
	title: $t("meta.about.title"),
	description: $t("meta.about.description"),
	ogTitle: $t("meta.about.title"),
	ogDescription: $t("meta.about.description"),
	twitterTitle: $t("meta.about.title"),
	twitterDescription: $t("meta.about.description"),
	ogType: "website",
	ogUrl: href,
});

useServerSeoMeta({
	title: $t("meta.about.title"),
	description: $t("meta.about.description"),
	ogTitle: $t("meta.about.title"),
	ogDescription: $t("meta.about.description"),
	twitterTitle: $t("meta.about.title"),
	twitterDescription: $t("meta.about.description"),
	ogType: "website",
	ogUrl: href,
});

const config = useRuntimeConfig();

const siteOrigin = computed(() =>
	String(
		config.public.BASE_URL ?? "https://suryabintangadventures.com",
	).replace(/\/$/, ""),
);

const structuredAbout = computed(() => {
	const siteRoot = `${siteOrigin.value}/`;
	return {
		"@context": "https://schema.org",
		"@graph": [
			{
				"@type": "BreadcrumbList",
				"@id": `${href}#breadcrumb`,
				itemListElement: [
					{
						"@type": "ListItem",
						position: 1,
						name: $t("nav.home"),
						item: siteRoot,
					},
					{
						"@type": "ListItem",
						position: 2,
						name: $t("nav.about"),
						item: href,
					},
				],
			},
			{
				"@type": "AboutPage",
				"@id": `${href}#webpage`,
				url: href,
				name: $t("meta.about.title"),
				description: $t("meta.about.description"),
				isPartOf: { "@id": `${siteRoot}#website`, "@type": "WebSite" },
				breadcrumb: { "@id": `${href}#breadcrumb` },
			},
		],
	};
});

useHead(() => ({
	titleTemplate: "%s",
	link: [
		{
			rel: "canonical",
			href: href,
		},
	],
	script: [
		{
			type: "application/ld+json",
			children: JSON.stringify(structuredAbout.value),
		},
	],
}));
</script>

<style scoped></style>
